import supabase from 'modules/core/supabase/supabase';
import { type IBroadcast } from 'modules/core/supabase/tables/broadcast';
import { setBroadcastState, setIsBroadcastInitialized } from 'modules/overlay-v2/store/overlay/overlay';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from 'store/hooks';

function useInitBroadcast() {
  const dispatch = useAppDispatch();
  const { deviceId } = useParams();
  const id = useMemo(() => (deviceId ? Number(deviceId) : undefined), [deviceId]);

  const [broadcast, setBroadcast] = useState<IBroadcast | undefined>(supabase.broadcast.data.value);

  useEffect(() => {
    if (!id) return;
    dispatch(setIsBroadcastInitialized(false));
    supabase.broadcast.fetchByDeviceId(id)
      .then((result) => {
        supabase.broadcast.data.value = result;
      })
      .catch((e) => {
        console.error(e);
        supabase.broadcast.data.value = undefined;
      })
      .finally(() => {
        dispatch(setIsBroadcastInitialized(true));
      });

    supabase.broadcast.observeByDeviceId(id);

    return () => {
      supabase.broadcast.stopObserve();
    };
  }, [id, dispatch]);

  useEffect(() => {
    const callback = (newValue: IBroadcast | undefined) => {
      setBroadcast(newValue);
      dispatch(setBroadcastState(newValue));
      console.debug('broadcast', newValue);
    };

    supabase.broadcast.data.subscribe(callback);

    return () => {
      supabase.broadcast.data.unsubscribe(callback);
    };
  }, [dispatch]);

  if (!id) throw Error('deviceId is required, check url param', { cause: 'useInitBroadcast' });

  return broadcast;
}

export default useInitBroadcast;
